module.exports = __webpack_public_path__ + "static/media/terminology-sales.4be56ebd.svg";